// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PoliciesRouteImport } from './routes/_policies'
import { Route as AgentLoginRouteImport } from './routes/agent-login'
import { Route as BlogRouteRouteImport } from './routes/blog/route'
import { Route as BrandingRouteImport } from './routes/branding'
import { Route as DocsRouteRouteImport } from './routes/docs/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as AuthedAdminRouteRouteImport } from './routes/_authed/admin/route'
import { Route as AuthedDeviceRouteImport } from './routes/_authed/device'
import { Route as AuthedInviteRouteImport } from './routes/_authed/invite'
import { Route as AuthedPortalRouteRouteImport } from './routes/_authed/portal/route'
import { Route as PoliciesCookiesRouteImport } from './routes/_policies/cookies'
import { Route as PoliciesCopyrightRouteImport } from './routes/_policies/copyright'
import { Route as PoliciesDataRequestRouteImport } from './routes/_policies/data-request'
import { Route as PoliciesDpaRouteImport } from './routes/_policies/dpa'
import { Route as PoliciesPrivacyPolicyRouteImport } from './routes/_policies/privacy-policy'
import { Route as PoliciesTermsRouteImport } from './routes/_policies/terms'
import { Route as PoliciesTrustRouteImport } from './routes/_policies/trust'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsSplatRouteImport } from './routes/docs/$'
import { Route as StatusStylePreviewStateRouteImport } from './routes/status-style-preview/$state'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedGoSplatRouteImport } from './routes/_authed/go/$'
import { Route as AuthedOauthAuthorizeRouteImport } from './routes/_authed/oauth/authorize'
import { Route as AuthedPortalIndexRouteImport } from './routes/_authed/portal/index'
import { Route as AuthedPortalDesignSystemRouteImport } from './routes/_authed/portal/design-system'
import { Route as AuthedPortalOrg_Char123orgKeyChar125RouteRouteImport } from './routes/_authed/portal/org_{$orgKey}/route'
import { Route as AuthedPortalProfileRouteImport } from './routes/_authed/portal/profile'
import { Route as AuthedPortalProj_Char123projectKeyChar125RouteRouteImport } from './routes/_authed/portal/proj_{$projectKey}/route'
import { Route as AuthedPortalSupportRouteImport } from './routes/_authed/portal/support'
import { Route as AuthedPortalOrg_Char123orgKeyChar125IndexRouteImport } from './routes/_authed/portal/org_{$orgKey}/index'
import { Route as AuthedPortalOrg_Char123orgKeyChar125BillingRouteImport } from './routes/_authed/portal/org_{$orgKey}/billing'
import { Route as AuthedPortalOrg_Char123orgKeyChar125MembersRouteImport } from './routes/_authed/portal/org_{$orgKey}/members'
import { Route as AuthedPortalOrg_Char123orgKeyChar125SettingsRouteImport } from './routes/_authed/portal/org_{$orgKey}/settings'
import { Route as AuthedPortalProj_Char123projectKeyChar125IndexRouteImport } from './routes/_authed/portal/proj_{$projectKey}/index'
import { Route as AuthedPortalProj_Char123projectKeyChar125AlertsRouteImport } from './routes/_authed/portal/proj_{$projectKey}/alerts'
import { Route as AuthedPortalProj_Char123projectKeyChar125ApiKeysRouteImport } from './routes/_authed/portal/proj_{$projectKey}/api-keys'
import { Route as AuthedPortalProj_Char123projectKeyChar125AppealsRouteImport } from './routes/_authed/portal/proj_{$projectKey}/appeals'
import { Route as AuthedPortalProj_Char123projectKeyChar125ConnectorsRouteImport } from './routes/_authed/portal/proj_{$projectKey}/connectors'
import { Route as AuthedPortalProj_Char123projectKeyChar125FilesRouteImport } from './routes/_authed/portal/proj_{$projectKey}/files'
import { Route as AuthedPortalProj_Char123projectKeyChar125HumanReviewRouteImport } from './routes/_authed/portal/proj_{$projectKey}/human-review'
import { Route as AuthedPortalProj_Char123projectKeyChar125MembersRouteImport } from './routes/_authed/portal/proj_{$projectKey}/members'
import { Route as AuthedPortalProj_Char123projectKeyChar125MetadataRouteImport } from './routes/_authed/portal/proj_{$projectKey}/metadata'
import { Route as AuthedPortalProj_Char123projectKeyChar125SettingsRouteImport } from './routes/_authed/portal/proj_{$projectKey}/settings'
import { Route as AuthedPortalProj_Char123projectKeyChar125UploadPresetsRouteImport } from './routes/_authed/portal/proj_{$projectKey}/upload-presets'
import { Route as AuthedPortalProj_Char123projectKeyChar125UsageRouteImport } from './routes/_authed/portal/proj_{$projectKey}/usage'
import { Route as AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesIndexRouteImport } from './routes/_authed/portal/org_{$orgKey}/moderation-policies/index'
import { Route as AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteImport } from './routes/_authed/portal/org_{$orgKey}/moderation-policies/$policyId/route'
import { Route as AuthedPortalProj_Char123projectKeyChar125AssetsAssetIdRouteImport } from './routes/_authed/portal/proj_{$projectKey}/assets.$assetId'
import { Route as AuthedPortalProj_Char123projectKeyChar125HashListsIndexRouteImport } from './routes/_authed/portal/proj_{$projectKey}/hash-lists/index'
import { Route as AuthedPortalProj_Char123projectKeyChar125HashListsHashListIdRouteImport } from './routes/_authed/portal/proj_{$projectKey}/hash-lists/$hashListId'
import { Route as AuthedPortalProj_Char123projectKeyChar125LensesIndexRouteImport } from './routes/_authed/portal/proj_{$projectKey}/lenses/index'
import { Route as AuthedPortalProj_Char123projectKeyChar125LensesIdentifierRouteImport } from './routes/_authed/portal/proj_{$projectKey}/lenses/$identifier'
import { Route as AuthedPortalProj_Char123projectKeyChar125LensesNewRouteImport } from './routes/_authed/portal/proj_{$projectKey}/lenses/new'
import { Route as AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdIndexRouteImport } from './routes/_authed/portal/org_{$orgKey}/moderation-policies/$policyId/index'
import { Route as AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdCategoryRouteImport } from './routes/_authed/portal/org_{$orgKey}/moderation-policies/$policyId/$category'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const PoliciesRoute = PoliciesRouteImport.update({
            id: '/_policies',getParentRoute: () => rootRouteImport
          })
const AgentLoginRoute = AgentLoginRouteImport.update({
            id: '/agent-login',path: '/agent-login',getParentRoute: () => rootRouteImport
          })
const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BrandingRoute = BrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => rootRouteImport
          })
const DocsRouteRoute = DocsRouteRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const WaitlistRoute = WaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => rootRouteImport
          })
const AuthedAdminRouteRoute = AuthedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedRoute
          })
const AuthedDeviceRoute = AuthedDeviceRouteImport.update({
            id: '/device',path: '/device',getParentRoute: () => AuthedRoute
          })
const AuthedInviteRoute = AuthedInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => AuthedRoute
          })
const AuthedPortalRouteRoute = AuthedPortalRouteRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthedRoute
          })
const PoliciesCookiesRoute = PoliciesCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => PoliciesRoute
          })
const PoliciesCopyrightRoute = PoliciesCopyrightRouteImport.update({
            id: '/copyright',path: '/copyright',getParentRoute: () => PoliciesRoute
          })
const PoliciesDataRequestRoute = PoliciesDataRequestRouteImport.update({
            id: '/data-request',path: '/data-request',getParentRoute: () => PoliciesRoute
          })
const PoliciesDpaRoute = PoliciesDpaRouteImport.update({
            id: '/dpa',path: '/dpa',getParentRoute: () => PoliciesRoute
          })
const PoliciesPrivacyPolicyRoute = PoliciesPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => PoliciesRoute
          })
const PoliciesTermsRoute = PoliciesTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PoliciesRoute
          })
const PoliciesTrustRoute = PoliciesTrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => PoliciesRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRouteRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRouteRoute
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRouteRoute
          })
const DocsSplatRoute = DocsSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => DocsRouteRoute
          })
const StatusStylePreviewStateRoute = StatusStylePreviewStateRouteImport.update({
            id: '/status-style-preview/$state',path: '/status-style-preview/$state',getParentRoute: () => rootRouteImport
          })
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAdminRouteRoute
          })
const AuthedGoSplatRoute = AuthedGoSplatRouteImport.update({
            id: '/go/$',path: '/go/$',getParentRoute: () => AuthedRoute
          })
const AuthedOauthAuthorizeRoute = AuthedOauthAuthorizeRouteImport.update({
            id: '/oauth/authorize',path: '/oauth/authorize',getParentRoute: () => AuthedRoute
          })
const AuthedPortalIndexRoute = AuthedPortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalDesignSystemRoute = AuthedPortalDesignSystemRouteImport.update({
            id: '/design-system',path: '/design-system',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125RouteRoute = AuthedPortalOrg_Char123orgKeyChar125RouteRouteImport.update({
            id: '/org_{$orgKey}',path: '/org_{$orgKey}',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalProfileRoute = AuthedPortalProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125RouteRoute = AuthedPortalProj_Char123projectKeyChar125RouteRouteImport.update({
            id: '/proj_{$projectKey}',path: '/proj_{$projectKey}',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalSupportRoute = AuthedPortalSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthedPortalRouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125IndexRoute = AuthedPortalOrg_Char123orgKeyChar125IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125BillingRoute = AuthedPortalOrg_Char123orgKeyChar125BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125MembersRoute = AuthedPortalOrg_Char123orgKeyChar125MembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125SettingsRoute = AuthedPortalOrg_Char123orgKeyChar125SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125IndexRoute = AuthedPortalProj_Char123projectKeyChar125IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125AlertsRoute = AuthedPortalProj_Char123projectKeyChar125AlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125ApiKeysRoute = AuthedPortalProj_Char123projectKeyChar125ApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125AppealsRoute = AuthedPortalProj_Char123projectKeyChar125AppealsRouteImport.update({
            id: '/appeals',path: '/appeals',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125ConnectorsRoute = AuthedPortalProj_Char123projectKeyChar125ConnectorsRouteImport.update({
            id: '/connectors',path: '/connectors',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125FilesRoute = AuthedPortalProj_Char123projectKeyChar125FilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125HumanReviewRoute = AuthedPortalProj_Char123projectKeyChar125HumanReviewRouteImport.update({
            id: '/human-review',path: '/human-review',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125MembersRoute = AuthedPortalProj_Char123projectKeyChar125MembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125MetadataRoute = AuthedPortalProj_Char123projectKeyChar125MetadataRouteImport.update({
            id: '/metadata',path: '/metadata',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125SettingsRoute = AuthedPortalProj_Char123projectKeyChar125SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125UploadPresetsRoute = AuthedPortalProj_Char123projectKeyChar125UploadPresetsRouteImport.update({
            id: '/upload-presets',path: '/upload-presets',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125UsageRoute = AuthedPortalProj_Char123projectKeyChar125UsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesIndexRoute = AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesIndexRouteImport.update({
            id: '/moderation-policies/',path: '/moderation-policies/',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRoute = AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteImport.update({
            id: '/moderation-policies/$policyId',path: '/moderation-policies/$policyId',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125AssetsAssetIdRoute = AuthedPortalProj_Char123projectKeyChar125AssetsAssetIdRouteImport.update({
            id: '/assets/$assetId',path: '/assets/$assetId',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125HashListsIndexRoute = AuthedPortalProj_Char123projectKeyChar125HashListsIndexRouteImport.update({
            id: '/hash-lists/',path: '/hash-lists/',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125HashListsHashListIdRoute = AuthedPortalProj_Char123projectKeyChar125HashListsHashListIdRouteImport.update({
            id: '/hash-lists/$hashListId',path: '/hash-lists/$hashListId',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125LensesIndexRoute = AuthedPortalProj_Char123projectKeyChar125LensesIndexRouteImport.update({
            id: '/lenses/',path: '/lenses/',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125LensesIdentifierRoute = AuthedPortalProj_Char123projectKeyChar125LensesIdentifierRouteImport.update({
            id: '/lenses/$identifier',path: '/lenses/$identifier',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalProj_Char123projectKeyChar125LensesNewRoute = AuthedPortalProj_Char123projectKeyChar125LensesNewRouteImport.update({
            id: '/lenses/new',path: '/lenses/new',getParentRoute: () => AuthedPortalProj_Char123projectKeyChar125RouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdIndexRoute = AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRoute
          })
const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdCategoryRoute = AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdCategoryRouteImport.update({
            id: '/$category',path: '/$category',getParentRoute: () => AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRoute
          })





const BlogRouteRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)




const DocsRouteRouteChildren = {
  DocsSplatRoute: DocsSplatRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(DocsRouteRouteChildren)




const AuthedAdminRouteRouteChildren = {
  AuthedAdminIndexRoute: AuthedAdminIndexRoute
}

const AuthedAdminRouteRouteWithChildren = AuthedAdminRouteRoute._addFileChildren(AuthedAdminRouteRouteChildren)




const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteChildren = {
  AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdCategoryRoute: AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdCategoryRoute,AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdIndexRoute: AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdIndexRoute
}

const AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteWithChildren = AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRoute._addFileChildren(AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteChildren)



const AuthedPortalOrg_Char123orgKeyChar125RouteRouteChildren = {
  AuthedPortalOrg_Char123orgKeyChar125BillingRoute: AuthedPortalOrg_Char123orgKeyChar125BillingRoute,AuthedPortalOrg_Char123orgKeyChar125MembersRoute: AuthedPortalOrg_Char123orgKeyChar125MembersRoute,AuthedPortalOrg_Char123orgKeyChar125SettingsRoute: AuthedPortalOrg_Char123orgKeyChar125SettingsRoute,AuthedPortalOrg_Char123orgKeyChar125IndexRoute: AuthedPortalOrg_Char123orgKeyChar125IndexRoute,AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRoute: AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesPolicyIdRouteRouteWithChildren,AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesIndexRoute: AuthedPortalOrg_Char123orgKeyChar125ModerationPoliciesIndexRoute
}

const AuthedPortalOrg_Char123orgKeyChar125RouteRouteWithChildren = AuthedPortalOrg_Char123orgKeyChar125RouteRoute._addFileChildren(AuthedPortalOrg_Char123orgKeyChar125RouteRouteChildren)




const AuthedPortalProj_Char123projectKeyChar125RouteRouteChildren = {
  AuthedPortalProj_Char123projectKeyChar125AlertsRoute: AuthedPortalProj_Char123projectKeyChar125AlertsRoute,AuthedPortalProj_Char123projectKeyChar125ApiKeysRoute: AuthedPortalProj_Char123projectKeyChar125ApiKeysRoute,AuthedPortalProj_Char123projectKeyChar125AppealsRoute: AuthedPortalProj_Char123projectKeyChar125AppealsRoute,AuthedPortalProj_Char123projectKeyChar125ConnectorsRoute: AuthedPortalProj_Char123projectKeyChar125ConnectorsRoute,AuthedPortalProj_Char123projectKeyChar125FilesRoute: AuthedPortalProj_Char123projectKeyChar125FilesRoute,AuthedPortalProj_Char123projectKeyChar125HumanReviewRoute: AuthedPortalProj_Char123projectKeyChar125HumanReviewRoute,AuthedPortalProj_Char123projectKeyChar125MembersRoute: AuthedPortalProj_Char123projectKeyChar125MembersRoute,AuthedPortalProj_Char123projectKeyChar125MetadataRoute: AuthedPortalProj_Char123projectKeyChar125MetadataRoute,AuthedPortalProj_Char123projectKeyChar125SettingsRoute: AuthedPortalProj_Char123projectKeyChar125SettingsRoute,AuthedPortalProj_Char123projectKeyChar125UploadPresetsRoute: AuthedPortalProj_Char123projectKeyChar125UploadPresetsRoute,AuthedPortalProj_Char123projectKeyChar125UsageRoute: AuthedPortalProj_Char123projectKeyChar125UsageRoute,AuthedPortalProj_Char123projectKeyChar125IndexRoute: AuthedPortalProj_Char123projectKeyChar125IndexRoute,AuthedPortalProj_Char123projectKeyChar125AssetsAssetIdRoute: AuthedPortalProj_Char123projectKeyChar125AssetsAssetIdRoute,AuthedPortalProj_Char123projectKeyChar125HashListsHashListIdRoute: AuthedPortalProj_Char123projectKeyChar125HashListsHashListIdRoute,AuthedPortalProj_Char123projectKeyChar125LensesIdentifierRoute: AuthedPortalProj_Char123projectKeyChar125LensesIdentifierRoute,AuthedPortalProj_Char123projectKeyChar125LensesNewRoute: AuthedPortalProj_Char123projectKeyChar125LensesNewRoute,AuthedPortalProj_Char123projectKeyChar125HashListsIndexRoute: AuthedPortalProj_Char123projectKeyChar125HashListsIndexRoute,AuthedPortalProj_Char123projectKeyChar125LensesIndexRoute: AuthedPortalProj_Char123projectKeyChar125LensesIndexRoute
}

const AuthedPortalProj_Char123projectKeyChar125RouteRouteWithChildren = AuthedPortalProj_Char123projectKeyChar125RouteRoute._addFileChildren(AuthedPortalProj_Char123projectKeyChar125RouteRouteChildren)



const AuthedPortalRouteRouteChildren = {
  AuthedPortalOrg_Char123orgKeyChar125RouteRoute: AuthedPortalOrg_Char123orgKeyChar125RouteRouteWithChildren,AuthedPortalProj_Char123projectKeyChar125RouteRoute: AuthedPortalProj_Char123projectKeyChar125RouteRouteWithChildren,AuthedPortalDesignSystemRoute: AuthedPortalDesignSystemRoute,AuthedPortalProfileRoute: AuthedPortalProfileRoute,AuthedPortalSupportRoute: AuthedPortalSupportRoute,AuthedPortalIndexRoute: AuthedPortalIndexRoute
}

const AuthedPortalRouteRouteWithChildren = AuthedPortalRouteRoute._addFileChildren(AuthedPortalRouteRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRouteRoute: AuthedAdminRouteRouteWithChildren,AuthedPortalRouteRoute: AuthedPortalRouteRouteWithChildren,AuthedDeviceRoute: AuthedDeviceRoute,AuthedInviteRoute: AuthedInviteRoute,AuthedGoSplatRoute: AuthedGoSplatRoute,AuthedOauthAuthorizeRoute: AuthedOauthAuthorizeRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)




const PoliciesRouteChildren = {
  PoliciesCookiesRoute: PoliciesCookiesRoute,PoliciesCopyrightRoute: PoliciesCopyrightRoute,PoliciesDataRequestRoute: PoliciesDataRequestRoute,PoliciesDpaRoute: PoliciesDpaRoute,PoliciesPrivacyPolicyRoute: PoliciesPrivacyPolicyRoute,PoliciesTermsRoute: PoliciesTermsRoute,PoliciesTrustRoute: PoliciesTrustRoute
}

const PoliciesRouteWithChildren = PoliciesRoute._addFileChildren(PoliciesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRouteRoute: BlogRouteRouteWithChildren,DocsRouteRoute: DocsRouteRouteWithChildren,AuthedRoute: AuthedRouteWithChildren,PoliciesRoute: PoliciesRouteWithChildren,AgentLoginRoute: AgentLoginRoute,BrandingRoute: BrandingRoute,LoginRoute: LoginRoute,MaintenanceRoute: MaintenanceRoute,MarketingRoute: MarketingRoute,RegisterRoute: RegisterRoute,WaitlistRoute: WaitlistRoute,StatusStylePreviewStateRoute: StatusStylePreviewStateRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)